var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getDataValue, removeDataValue } from '@juvare/json-data-util';
import React from 'react';
import { QuickSearch } from '../components';
export function quickSearchFilter(params) {
    return {
        quickFilter: {
            render: (props) => (React.createElement(QuickSearch, Object.assign({}, props, { dataPath: params.dataPath, label: params.label, sx: params.sx, "data-test": params.dataTest }))),
            dataPath: params.dataPath,
        },
        widgetConfig: {
            type: 'form.text',
            key: params.dataPath,
            label: params.label,
        },
        getFilterChips: (filterData) => __awaiter(this, void 0, void 0, function* () {
            const value = getDataValue(filterData, params.dataPath);
            if (typeof value === 'string' && value) {
                return [
                    {
                        label: value,
                        onRemoveChip: (chipFilterData) => handleRemoveChip(chipFilterData, params.dataPath),
                        groupId: params.dataPath,
                    },
                ];
            }
            else {
                return [];
            }
        }),
    };
}
function handleRemoveChip(filterData, dataPath) {
    const newFilterData = JSON.parse(JSON.stringify(filterData));
    removeDataValue(newFilterData, dataPath);
    return newFilterData;
}
